import { useTranslation } from 'next-i18next/pages';
import { type CountryCode } from '@pkgs/api';

import { TRANSLATION_NAMESPACE } from '@/i18n/config';
import { useUserData } from '@/hooks/useUserData';

import { PhoneInputField } from '../../PhoneInput/PhoneInput';

export const PhoneInput = ({
  initialCountry,
  isInModal,
  isRequired,
}: {
  initialCountry: CountryCode;
  isInModal?: boolean;
  isRequired?: boolean;
}) => {
  const { t } = useTranslation(TRANSLATION_NAMESPACE.property_expose);
  const { userData, isSignedInAndUserDataNotLoaded } = useUserData();

  if (isSignedInAndUserDataNotLoaded) return null;

  return (
    <PhoneInputField
      defaultValue={userData?.phoneNumber}
      label={t('search.contact.form.label.phoneNumber')}
      name="phoneNumber"
      autoComplete="tel"
      isRequired={isRequired}
      validationMessages={{
        valueMissing: t('search.contact.form.validation.phoneNumber.required'),
      }}
      id="contact-form-phone-input-field"
      initialCountry={initialCountry}
      size="m"
      isInModal={isInModal}
    />
  );
};
